import { render } from "./PlaceInfo.vue?vue&type=template&id=5c1a2b5f&scoped=true"
import script from "./PlaceInfo.vue?vue&type=script&lang=js"
export * from "./PlaceInfo.vue?vue&type=script&lang=js"

import "./PlaceInfo.vue?vue&type=style&index=0&id=5c1a2b5f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1a2b5f"]])

export default __exports__